<template>
  <!--START SOCIAL-->
  <section class="cta bg-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <ul class="list-inline social margin-t-20">
            <li class="list-inline-item">
              <a href="" class="social-icon"
                ><i class="mdi mdi-facebook"></i
              ></a>
            </li>
            <li class="list-inline-item">
              <a href="" class="social-icon"><i class="mdi mdi-twitter"></i></a>
            </li>
            <li class="list-inline-item">
              <a href="" class="social-icon"
                ><i class="mdi mdi-linkedin"></i
              ></a>
            </li>
            <li class="list-inline-item">
              <a href="" class="social-icon"
                ><i class="mdi mdi-google-plus"></i
              ></a>
            </li>
          </ul>
        </div>
        <div class="col-lg-3 margin-t-30">
          <p class="margin-b-0 contact-title">
            <i class="pe-7s-call"></i> &nbsp;+91 123 4556 789
          </p>
        </div>
        <div class="col-lg-3 margin-t-30 text-right">
          <p class="contact-title">
            <i class="pe-7s-mail-open"></i>&nbsp; Suporte@start.com
          </p>
        </div>
      </div>
    </div>
  </section>
  <!--END SOCIAL-->
</template>

<script>
"use strict";
export default {
  name: "Social",
  props: {}
};
</script>
